import React from 'react';

import styles from './index.module.scss';
import { branch } from 'baobab-react/higher-order';
import {
  meSelector,
  agentsSelector,
  clientsSelector,
  reportsSelector,
  institutionsSelector,
  positionsSelector,
  eventsSelector,
  meetingsSelector,
  investsSelector,
} from '../../store/struct/selectors';
import Table, { TYPES as TABLE_TYPES } from '../../components/table';
import AGENT_STRUCT from '../../store/struct/entities/agent';
import REPORT_STRUCT from '../../store/struct/entities/report';
import CLIENT_STRUCT from '../../store/struct/entities/client';
import INSTITUTION_STRUCT from '../../store/struct/entities/institution';
import POSITION_STRUCT from '../../store/struct/entities/position';
import EVENT_STRUCT from '../../store/struct/entities/event';
import USER_STRUCT from '../../store/struct/entities/event';
import { getById } from '../../utils';
import { THEMES } from '../../components/button';
import InfoIcon from '../../components/Icons/info-icon/infoIcon';
import { toDecimalPlaces } from '../../utils';

import InvestDialog from '../client/investDialog';
import ResultDialog from '../client/resultDialog';

import commonStyles from '../../styles/common.module.scss';
import INVEST_STRUCT from '../../store/struct/entities/invest';
import { roleSelector } from '../../store/struct/app/selectors';
import { ROLES } from '../../store/struct/entities/role';
import find from 'lodash.find';

const TABLE_HEADERS = [
  'Представитель',
  'Учереждение',
  'Должность',
  'ФИО',
  'Время',
  'Аргументы',
  'Инвестиции',
  '6IBs',
  'Результат',
];

export const getCorrespondingInvestId = (eventId, clientId, invests) => {
  const invest = find(
    invests,
    invest => invest[INVEST_STRUCT.CUSTOMER_ID] === clientId && invest[INVEST_STRUCT.EVENT_ID] === eventId,
  );

  return invest[INVEST_STRUCT.ID];
};

class Reports extends React.Component {
  state = {
    investDialogVisible: false,
    selectedReport: null,
  };

  resultsTableConfig = [
    {
      type: TABLE_TYPES.TEXT,
      getValue: report => {
        const agent = getById(this.props.agents, report[REPORT_STRUCT.REPRESENTATIVE_ID]);

        return agent ? agent[AGENT_STRUCT.NAME] : '';
      },
    },
    {
      type: TABLE_TYPES.TEXT,
      getValue: report => {
        const client = getById(this.props.clients, report[REPORT_STRUCT.CLIENT_ID]);
        const institution = client ? getById(this.props.institutions, client[CLIENT_STRUCT.INSTITUTION_ID]) : '';

        return institution ? institution[INSTITUTION_STRUCT.NAME] : '';
      },
    },
    {
      type: TABLE_TYPES.TEXT,
      getValue: report => {
        const client = getById(this.props.clients, report[REPORT_STRUCT.CLIENT_ID]);
        const positionId = client ? client[CLIENT_STRUCT.POSITION_ID] : '';
        const position = getById(this.props.positions, positionId);

        return position ? position[POSITION_STRUCT.NAME] : '';
      },
    },
    {
      type: TABLE_TYPES.TEXT,
      getValue: report => {
        const client = getById(this.props.clients, report[REPORT_STRUCT.CLIENT_ID]);

        return client ? client[CLIENT_STRUCT.NAME] : '';
      },
    },
    {
      type: TABLE_TYPES.TEXT,
      getValue: report => {
        return report[REPORT_STRUCT.PLANNED_START].substr(11, 5);
      },
    },
    {
      type: TABLE_TYPES.TEXT,
      getValue: report => {
        return `${report[REPORT_STRUCT.ARGUMENTS_USED]}/${report[REPORT_STRUCT.ARGUMENTS_TOTAL]}`;
      },
    },
    [
      {
        type: TABLE_TYPES.TEXT,
        style: {
          display: 'inline-block',
          // minWidth: '50px',
        },
        getValue: report => {
          const events = report[REPORT_STRUCT.APPOINTED_EVENTS];

          return events.reduce((acc, eventId) => {
            const investForEvent = find(this.props.invests, invest => {
              return (
                report[REPORT_STRUCT.CLIENT_ID] === invest[INVEST_STRUCT.CUSTOMER_ID] &&
                eventId === invest[INVEST_STRUCT.EVENT_ID]
              );
            });

            const event = getById(this.props.events, eventId);

            const cost = investForEvent[INVEST_STRUCT.FINE] ? event[EVENT_STRUCT.FINE] : event[EVENT_STRUCT.COST];

            return acc + cost;
          }, 0);
        },
      },
      {
        type: TABLE_TYPES.BUTTON,
        onClick: report => {
          this.setState({ investDialogVisible: true, selectedReport: { ...report } });
        },
        getProps: () => ({
          className: styles.addBtn,
        }),
        render: InfoIcon,
        theme: THEMES.PRIMARY,
      },
    ],
    {
      type: TABLE_TYPES.TEXT,
      getValue: report => {
        const grades = report[REPORT_STRUCT.GRADES].split(',');
        return grades
          .map(grade => {
            const converted = parseFloat(grade);
            return isNaN(converted) ? grade : toDecimalPlaces(converted, 1);
          })
          .join(', ');
      },
    },
    {
      type: TABLE_TYPES.BUTTON,
      onClick: report => {
        this.setState({ selectedReport: { ...report } });
      },
      text: 'Результат',
      theme: THEMES.PRIMARY,
      min: true,
    },
  ];
  resultsTableHeaderConfig = [
    {
      props: { className: commonStyles.headerSelect },
    },
    {
      props: { className: commonStyles.headerSelect },
    },
  ];
  resultsTableRowConfig = {
    getKey: rowData => `${rowData[REPORT_STRUCT.REPRESENTATIVE_ID]}_${rowData[REPORT_STRUCT.MEETING_RESULTS_ID]}`,
  };

  closeDialog = () => {
    this.setState({
      selectedReport: null,
      investDialogVisible: false,
    });
  };

  render() {
    const { currentUser, role } = this.props;

    if (!currentUser) {
      return '';
    }
    const { selectedReport, investDialogVisible } = this.state;

    let investIds;
    if (selectedReport) {
      let eventIds = selectedReport[REPORT_STRUCT.APPOINTED_EVENTS];

      investIds = eventIds.map(eventId => {
        const clientId = selectedReport[REPORT_STRUCT.CLIENT_ID];
        return getCorrespondingInvestId(eventId, clientId, this.props.invests);
      });
    }

    let reports =
      role === ROLES.AGENT
        ? this.props.reports.filter(report => report[REPORT_STRUCT.REPRESENTATIVE_ID] === currentUser[USER_STRUCT.ID])
        : this.props.reports;

    return (
      <>
        {reports.length !== 0 ? (
          <Table
            keyName={'client_id'}
            data={reports}
            filters={role === ROLES.AGENT ? [0] : [0, 1]}
            headers={role === ROLES.AGENT ? TABLE_HEADERS.slice(1) : TABLE_HEADERS}
            rowConfig={this.resultsTableRowConfig}
            headerConfig={this.resultsTableHeaderConfig}
            config={role === ROLES.AGENT ? this.resultsTableConfig.slice(1) : this.resultsTableConfig}
            className={styles.tableWithHeader}
          />
        ) : role === ROLES.AGENT ? (
          'На данный момент Вами не проведено ни одной встречи'
        ) : (
          'На данный момент в игре не проведено ни одной встречи'
        )}
        {!investDialogVisible && selectedReport && (
          <ResultDialog onCancel={this.closeDialog} selectedReport={selectedReport} />
        )}
        {investDialogVisible && selectedReport && <InvestDialog onCancel={this.closeDialog} investIds={investIds} />}
      </>
    );
  }
}

export default branch(
  {
    currentUser: meSelector(),
    agents: agentsSelector(),
    clients: clientsSelector(),
    reports: reportsSelector(),
    institutions: institutionsSelector(),
    positions: positionsSelector(),
    events: eventsSelector(),
    meetings: meetingsSelector(),
    invests: investsSelector(),
    role: roleSelector(),
  },
  Reports,
);
